import React from 'react'
import "./Header.css"

const Header = () => {
    return (
        <div className="header-nav">
            <div className='container d-flex flex-column' style={{ color: "#ffffff", cursor: "pointer" }}>
                <p style={{ fontSize: '2rem' }} className="mt-2">Linko</p>
                <p style={{ fontSize: '0.9rem', marginTop: "-20px" }}>Create Personalized Post</p>
            </div>
        </div>
    )
}

export default Header